import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Divider,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { MappingImportResponseContext } from 'utils/context';
import './accordionMappingError.scss';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const AccordionErrorMappingImport = ({ from = 'mappingCulture' }) => {
  const { t } = useTranslation();
  const {
    cultureMappingImportResponse,
    groundTypeMappingImportResponse,
    setCultureMappingImportResponse,
    setGroundTypeMappingImportResponse,
  } = useContext(MappingImportResponseContext);

  const mappingResponse =
    from === 'mappingCulture' ? cultureMappingImportResponse : groundTypeMappingImportResponse;

  const setMappingImportResponse =
    from === 'mappingCulture'
      ? setCultureMappingImportResponse
      : setGroundTypeMappingImportResponse;

  if (!mappingResponse.hasWarning) return;

  return (
    <Accordion className="accordion_mapping_error">
      <AccordionSummary
        expandIcon={
          <Box>
            <ExpandMoreIcon />
          </Box>
        }
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Box className="accordion_summary_content_wrapper">
          <WarningAmberIcon className="warning" />
          {mappingResponse.skippedLines.length > 0 && (
            <Typography component="span">
              {t('message.skippedLinesCount', { count: mappingResponse.skippedLines.length })}
            </Typography>
          )}
          {mappingResponse.skippedLines.length > 0 && mappingResponse.warningInfo.length > 0 && (
            <Divider className="divider" orientation="vertical" flexItem />
          )}
          {mappingResponse.warningInfo.length > 0 && (
            <Typography component="span">
              {t('message.warningCount', { count: mappingResponse.warningInfo.length })}
            </Typography>
          )}
          <Button
            component="label"
            className="close_button"
            startIcon={<CloseIcon />}
            variant="outlined"
            onClick={(e) => {
              e.stopPropagation();
              setMappingImportResponse({
                skippedLines: [],
                warningInfo: [],
                hasWarning: false,
                mappingType: null,
              });
            }}
          >
            {t('common.close')}
          </Button>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        {mappingResponse.skippedLines.length > 0 && (
          <>
            <Typography variant="h6" gutterBottom>
              {t('label.skippedLines')}
            </Typography>
            <Box className="flex_wrap">
              {mappingResponse.skippedLines.map((skippedLine, index) => (
                <Typography key={index} component="div" variant="body2" className="error_line">
                  {skippedLine.externalName && (
                    <React.Fragment>
                      <span className="bold_span">{t('label.externalName').toLowerCase()}</span> :{' '}
                      {skippedLine.externalName}{' '}
                    </React.Fragment>
                  )}{' '}
                  ({t('label.line')} : {skippedLine.line}){' '}
                  <span className="bold_span">{t('label.reason')} : </span>
                  {skippedLine.reason}
                </Typography>
              ))}
            </Box>
          </>
        )}
        {mappingResponse.warningInfo.length > 0 && (
          <>
            <Typography variant="h6" gutterBottom>
              {t('label.alert')}
            </Typography>
            <Box className="flex_wrap">
              {mappingResponse.warningInfo.map((errorLine, index) => (
                <Typography key={index} component="div" variant="body2" className="error_line">
                  <span className="bold_span">{t('label.externalName').toLowerCase()}</span> :{' '}
                  {errorLine.externalName} ({t('label.line')} : {errorLine.line}){' '}
                  <span className="bold_span">{t('label.reason')} : </span>
                  {errorLine.reason}
                </Typography>
              ))}
            </Box>
          </>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default AccordionErrorMappingImport;
